module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-right-panel-1-a7aaf5f5b03e96680cd6f4e538baa272.svg";